import { render, staticRenderFns } from "./Dimmed.vue?vue&type=template&id=49783593&scoped=true"
import script from "./Dimmed.vue?vue&type=script&lang=js"
export * from "./Dimmed.vue?vue&type=script&lang=js"
import style0 from "./Dimmed.vue?vue&type=style&index=0&id=49783593&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49783593",
  null
  
)

export default component.exports